module.exports = __webpack_public_path__ + "static/img/star.1192a616.png";